var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRaffleFeatureIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.997,
    height: 81,
    viewBox: "0 0 80.997 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3193",
    "data-name": "Rectangle 3193",
    width: 66.589,
    height: 66.589,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_83193",
    "data-name": "Group 83193",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5587",
    "data-name": "Path 5587",
    d: "M40.5,0A40.5,40.5,0,1,1,0,40.5,40.5,40.5,0,0,1,40.5,0Z",
    transform: "translate(0 0)",
    fill: "#ffeaae"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11573",
    "data-name": "Group 11573",
    transform: "translate(6.057 8.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11572",
    "data-name": "Group 11572",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5502",
    "data-name": "Path 5502",
    d: "M13.007,27.607V50.633a3,3,0,0,0,3,3H48.046a3,3,0,0,0,3-3V27.607Z",
    transform: "translate(2.413 0.358)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3184",
    "data-name": "Rectangle 3184",
    width: 38.042,
    height: 2.003,
    transform: "translate(15.419 27.964)",
    fill: "#2758a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5503",
    "data-name": "Path 5503",
    d: "M47.157,27.607V50.633a3,3,0,0,1-3,3h3a3,3,0,0,0,3-3V27.607Z",
    transform: "translate(3.302 0.358)",
    fill: "#2758a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5504",
    "data-name": "Path 5504",
    d: "M49.046,51.633H18.012a2,2,0,0,1-2-2V27.607h-3V50.633a3,3,0,0,0,3,3H48.046a3,3,0,0,0,3-3v-1a2,2,0,0,1-2,2",
    transform: "translate(2.413 0.358)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5505",
    "data-name": "Path 5505",
    d: "M44.153,53.025h3a3,3,0,0,0,3-3v-1a2,2,0,0,1-2,2H46.972a2.993,2.993,0,0,1-2.819,2",
    transform: "translate(3.302 0.969)",
    fill: "#ccdcff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3185",
    "data-name": "Rectangle 3185",
    width: 3.003,
    height: 2.003,
    transform: "translate(50.459 27.964)",
    fill: "#1b4a8e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3186",
    "data-name": "Rectangle 3186",
    width: 3.003,
    height: 2.003,
    transform: "translate(15.419 27.964)",
    fill: "#ccdcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5506",
    "data-name": "Path 5506",
    d: "M48.073,54.3H16.038a4.009,4.009,0,0,1-4-4V40.288a1,1,0,1,1,2,0V50.3a2.006,2.006,0,0,0,2,2H48.073a2.005,2.005,0,0,0,2-2V44.293a1,1,0,1,1,2,0V50.3a4.008,4.008,0,0,1-4,4",
    transform: "translate(2.386 0.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5507",
    "data-name": "Path 5507",
    d: "M51.076,41.649a1,1,0,0,1-1-1V28.635H14.034v5a1,1,0,1,1-2,0V27.634a1,1,0,0,1,1-1H51.076a1,1,0,0,1,1,1V40.649a1,1,0,0,1-1,1",
    transform: "translate(2.386 0.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5508",
    "data-name": "Path 5508",
    d: "M13.035,38.4a1,1,0,0,1-1-1v-1a1,1,0,1,1,2,0v1a1,1,0,0,1-1,1",
    transform: "translate(2.386 0.58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5509",
    "data-name": "Path 5509",
    d: "M51.1,19.82H13.063a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2H51.1a2,2,0,0,0,2-2v-4a2,2,0,0,0-2-2",
    transform: "translate(2.358 0.136)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5510",
    "data-name": "Path 5510",
    d: "M51.1,19.82h-2a1,1,0,0,1,1,1v4.005a1,1,0,0,1-1,1H12.062a1,1,0,0,1-1-1v1a2,2,0,0,0,2,2H51.1a2,2,0,0,0,2-2v-4a2,2,0,0,0-2-2",
    transform: "translate(2.358 0.136)",
    fill: "#2758a8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5511",
    "data-name": "Path 5511",
    d: "M51.1,19.82H13.063a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2h2a1,1,0,0,1-1-1v-4a1,1,0,0,1,1-1h37.04a1,1,0,0,1,1,1v-1a2,2,0,0,0-2-2",
    transform: "translate(2.358 0.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5512",
    "data-name": "Path 5512",
    d: "M14.063,26.689v-1h-2a1,1,0,0,1-1-1v1a2,2,0,0,0,2,2h2a1,1,0,0,1-1-1",
    transform: "translate(2.358 0.275)",
    fill: "#ccdcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5513",
    "data-name": "Path 5513",
    d: "M50.05,19.82h-2a1,1,0,0,1,1,1v1h2a1,1,0,0,1,1,1v-1a2,2,0,0,0-2-2",
    transform: "translate(3.413 0.136)",
    fill: "#ccdcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5514",
    "data-name": "Path 5514",
    d: "M51.131,28.858H13.09a3.006,3.006,0,0,1-3-3V21.849a3.006,3.006,0,0,1,3-3H51.131a3.007,3.007,0,0,1,3,3v4.005a3.007,3.007,0,0,1-3,3M13.09,20.849a1,1,0,0,0-1,1v4.005a1,1,0,0,0,1,1H51.131a1,1,0,0,0,1-1V21.849a1,1,0,0,0-1-1Z",
    transform: "translate(2.33 0.108)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3187",
    "data-name": "Rectangle 3187",
    width: 8.009,
    height: 26.029,
    transform: "translate(30.437 27.965)",
    fill: "#ffc629"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3188",
    "data-name": "Rectangle 3188",
    width: 8.009,
    height: 2.003,
    transform: "translate(30.437 27.964)",
    fill: "#ffa92c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3189",
    "data-name": "Rectangle 3189",
    width: 8.009,
    height: 2.003,
    transform: "translate(30.437 51.991)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5515",
    "data-name": "Path 5515",
    d: "M35.643,54.664H27.635a1,1,0,0,1-1-1V27.635a1,1,0,0,1,1-1h8.008a1,1,0,0,1,1,1V53.664a1,1,0,0,1-1,1m-7.007-2h6.007V28.635H28.635Z",
    transform: "translate(2.802 0.33)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3190",
    "data-name": "Rectangle 3190",
    width: 8.009,
    height: 8.009,
    transform: "translate(30.437 19.956)",
    fill: "#ffc629"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3191",
    "data-name": "Rectangle 3191",
    width: 8.009,
    height: 2.003,
    transform: "translate(30.437 25.962)",
    fill: "#ffa92c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3192",
    "data-name": "Rectangle 3192",
    width: 8.009,
    height: 2.003,
    transform: "translate(30.437 19.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5516",
    "data-name": "Path 5516",
    d: "M35.643,28.858H27.635a1,1,0,0,1-1-1V19.848a1,1,0,0,1,1-1h8.008a1,1,0,0,1,1,1v8.009a1,1,0,0,1-1,1m-7.007-2h6.007V20.848H28.635Z",
    transform: "translate(2.802 0.108)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5517",
    "data-name": "Path 5517",
    d: "M35.393,20.1l12.861-3.043a1.5,1.5,0,0,0,.793-2.439l-2.085-2.431a5.994,5.994,0,0,0-4.562-2.1,7.007,7.007,0,0,0-7.007,7.007Z",
    transform: "translate(3.052 -0.142)",
    fill: "#ffc629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5518",
    "data-name": "Path 5518",
    d: "M49.037,14.616l-2.086-2.431a5.994,5.994,0,0,0-4.56-2.1,7.01,7.01,0,0,0-6.638,4.756,6.983,6.983,0,0,1,4.636-1.753,6,6,0,0,1,4.562,2.1l1.886,2.2,1.408-.333a1.5,1.5,0,0,0,.793-2.439",
    transform: "translate(3.062 -0.142)",
    fill: "#ffa92c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5519",
    "data-name": "Path 5519",
    d: "M35.422,21.126a1,1,0,0,1-1-1v-3a8.018,8.018,0,0,1,8.009-8.009,7,7,0,0,1,5.321,2.448l2.086,2.43a2.5,2.5,0,0,1-1.323,4.065L35.652,21.1a.979.979,0,0,1-.23.027m7.007-10.011a6.014,6.014,0,0,0-6.007,6.007V18.86l11.63-2.752a.5.5,0,0,0,.384-.488.488.488,0,0,0-.12-.325l-2.085-2.431a5.005,5.005,0,0,0-3.8-1.748",
    transform: "translate(3.024 -0.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5520",
    "data-name": "Path 5520",
    d: "M28,20.1,15.135,17.054a1.5,1.5,0,0,1-.793-2.439l2.085-2.431a5.994,5.994,0,0,1,4.562-2.1A7.007,7.007,0,0,1,28,17.094Z",
    transform: "translate(2.441 -0.142)",
    fill: "#ffc629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5521",
    "data-name": "Path 5521",
    d: "M22.99,13.09a6.978,6.978,0,0,1,4.636,1.754,7.008,7.008,0,0,0-6.638-4.757,5.991,5.991,0,0,0-4.56,2.1l-2.086,2.43a1.5,1.5,0,0,0,.793,2.439l1.408.333,1.887-2.2a5.991,5.991,0,0,1,4.56-2.1",
    transform: "translate(2.441 -0.142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5522",
    "data-name": "Path 5522",
    d: "M28.022,21.126a.978.978,0,0,1-.23-.027L14.931,18.056a2.5,2.5,0,0,1-1.323-4.065l2.086-2.43a7,7,0,0,1,5.321-2.448,8.018,8.018,0,0,1,8.009,8.009v3a1,1,0,0,1-1,1M21.015,11.116a5.005,5.005,0,0,0-3.8,1.748L15.129,15.3a.488.488,0,0,0-.12.325.5.5,0,0,0,.384.488l11.63,2.752V17.122a6.014,6.014,0,0,0-6.007-6.007",
    transform: "translate(2.413 -0.169)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5523",
    "data-name": "Path 5523",
    d: "M32.612,14.953h-2a3,3,0,0,0-3,3v2h8.009v-2a3,3,0,0,0-3-3",
    transform: "translate(2.83 -0.003)",
    fill: "#ffc629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5524",
    "data-name": "Path 5524",
    d: "M32.612,15.954h2c.082,0,.16.019.242.026a2.984,2.984,0,0,0-2.244-1.026h-2a3,3,0,0,0-3,3v2h2v-1a3,3,0,0,1,3-3",
    transform: "translate(2.83 -0.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5525",
    "data-name": "Path 5525",
    d: "M35.643,20.988H27.635a1,1,0,0,1-1-1v-2a4.01,4.01,0,0,1,4.005-4.005h2a4.01,4.01,0,0,1,4.005,4.005v2a1,1,0,0,1-1,1m-7.007-2h6.007v-1a2,2,0,0,0-2-2h-2a2,2,0,0,0-2,2Z",
    transform: "translate(2.802 -0.031)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaffleFeatureIcon);
export default __webpack_public_path__ + "static/media/raffle_feature_icon.49794bfb1b2a1f988ae6086fccd6ea28.svg";
export { ForwardRef as ReactComponent };